import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VBtn,
    {
      staticClass:
        "branding-btn branding-btn--primary rounded-20 text-none text-subtitle-1",
      attrs: {
        depressed: "",
        color: "primary",
        height: "52",
        href: _vm.href,
        block: _setup.isMobile,
      },
    },
    [_vm._v("\n  " + _vm._s(_setup.label) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }